module.exports = __webpack_public_path__ + "img/ico_menu-popup.f0dca408.svg";